/** Symmetric cipher the persisted key session is encrypted with — see persisted-session.utils.ts. */
export const PERSISTED_SESSION_CIPHER_ALGORITHM = "AES-GCM";

export const PERSISTED_SESSION_KEY_LENGTH_BITS = 256;

/** 96 bits — the length AES-GCM is defined for; a fresh one per encryption. */
export const PERSISTED_SESSION_IV_LENGTH_BYTES = 12;
